// extracted by css-extract-rspack-plugin
export default {"cls1":"AboutTheAuthorsSection-cls1_X-b","cls2":"AboutTheAuthorsSection-cls2_5sH AboutTheAuthorsSection-cls1_X-b"};